// extracted by mini-css-extract-plugin
export default {"modal":"SmsModal_modal__v0y6i","header":"SmsModal_header__m4y2+","body":"SmsModal_body__4XX51","form":"SmsModal_form__XVnf0","formGroup":"SmsModal_formGroup__CUeFn"};